import { createRouter, createWebHistory } from "vue-router";
import AppLayout from "@/layout/AppLayout.vue";
import store from "@/store";
import External from "@/service/External";
import { IS_USER_AUTH_GETTERS } from "@/store/storeConstants";
import { getLocalStorage } from "@/service/LocalStorageService";
import { computed, ref } from "vue";

const router = createRouter({
  history: createWebHistory(),

  routes: [
    {
      path: "/",
      component: AppLayout,
      meta: { auth: true },
      children: [
        {
          path: "/",
          name: "dashboard",
          component: () => import("@/views/Dashboard.vue"),
        },
        {
          path: "/users/admin",
          name: "admin",
          beforeEnter: (to, from, next) => {
            if (store.state["auth"].isAdmin) {
              next();
            } else {
              next({ name: "dashboard" });
            }
          },
          component: () => import("@/views/pages/auth/Users.vue"),
        },
        {
          path: "/users/dealer",
          name: "dealers",
          meta: { auth: true },
          beforeEnter: (to, from, next) => {
            if (store.state["auth"].isAdmin) {
              next();
            } else {
              next({ name: "dashboard" });
            }
          },
          component: () => import("@/views/pages/dealer/Index.vue"),
        },
        {
          path: "/users/client",
          name: "clients",
          component: () => import("@/views/pages/client/Index.vue"),
        },

        {
          path: "/order/create",
          name: "orderCreate",
          meta: { auth: true },
          component: () => import("@/views/pages/order/Create.vue"),
        },
        {
          path: "/reports/dealer-sales",
          name: "reportDealerSales",
          meta: { auth: true },
          component: () =>
            import("@/views/pages/reports/DealerSalesReport.vue"),
        },
        {
          path: "/reports/dealer-all-sales",
          name: "reportDealerAllSales",
          meta: { auth: true },
          component: () =>
            import("@/views/pages/reports/DealerAllSalesReport.vue"),
        },
        {
          path: "/order/select/create/:id",
          name: "orderCreateWithProduct",
          meta: { auth: true },
          component: () => import("@/views/pages/order/Create.vue"),
        },
        {
          path: "/order/internal/index",
          name: "orderInternal",
          meta: { auth: true },
          component: () => import("@/views/pages/order/InternalOrder.vue"),
        },
        {
          path: "/order/external/index",
          name: "orderExternal",
          meta: { auth: true },
          component: () => import("@/views/pages/order/ExternalOrder.vue"),
        },

        {
          path: "/order/OrderDetail",
          name: "orderDetail",
          meta: { auth: true },
          component: () => import("@/views/pages/order/OrderDetail.vue"),
        },
        {
          path: "/order/internal/return",
          name: "orderInternalReturn",
          meta: { auth: true },
          component: () =>
            import("@/views/pages/order/ReturnInternalOrder.vue"),
        },
        {
          path: "/order/external/return",
          name: "orderExternalReturn",
          meta: { auth: true },
          component: () =>
            import("@/views/pages/order/ReturnExternalOrder.vue"),
        },
        {
          path: "/ratio/index",
          name: "ratio",
          beforeEnter: (to, from, next) => {
            if (store.state["auth"].isAdmin) {
              next();
            } else {
              next({ name: "dashboard" });
            }
          },
          meta: { auth: true },
          component: () => import("@/views/pages/ratio/Index.vue"),
        },
        {
          path: "/ratio/ratio",
          name: "ratioDone",
          beforeEnter: (to, from, next) => {
            if (store.state["auth"].isAdmin) {
              next();
            } else {
              next({ name: "dashboard" });
            }
          },
          meta: { auth: true },
          component: () => import("@/views/pages/ratio/Ratio.vue"),
        },
        {
          path: "/ratio/ratio/detail/:id",
          name: "ratioDetail",

          meta: { auth: true },
          component: () => import("@/views/pages/ratio/RatioDetail.vue"),
        },

        {
          path: "/reports/internal-orders-sales",
          name: "reportInternalOrdersSales",
          meta: { auth: true },
          component: () =>
            import("@/views/pages/reports/InternalOrdersSalesReport.vue"),
        },
        {
          path: "/reports/dealer",
          name: "reportDealer",
          meta: { auth: true },
          component: () => import("@/views/pages/reports/DealerReport.vue"),
        },
        {
          path: "/reports/provinces-sales",
          name: "reportProvincesSales",
          meta: { auth: true },
          component: () =>
            import("@/views/pages/reports/ProvincesSalesReport.vue"),
        },
        {
          path: "/reports/profit",
          name: "reportProfit",
          meta: { auth: true },
          component: () => import("@/views/pages/reports/DealerProfit.vue"),
        },
        {
          path: "/reports/payments",
          name: "reportPayments",
          meta: { auth: true },
          component: () => import("@/views/pages/reports/PaymentsReport.vue"),
        },
        {
          path: "/reports/all-profit",
          name: "reportAllProfit",
          meta: { auth: true },
          component: () => import("@/views/pages/reports/AllDealerProfit.vue"),
        },

        {
          path: "/catch/index",
          name: "catchReceipt",
          beforeEnter: (to, from, next) => {
            if (store.state["auth"].isAdmin) {
              next();
            } else {
              next({ name: "dashboard" });
            }
          },
          meta: { auth: true },
          component: () => import("@/views/pages/finance/receipts/Catch.vue"),
        },
        {
          path: "/payment/index",
          name: "paymentReceipt",
          meta: { auth: true },
          beforeEnter: (to, from, next) => {
            if (store.state["auth"].isAdmin) {
              next();
            } else {
              next({ name: "dashboard" });
            }
          },
          component: () => import("@/views/pages/finance/receipts/Payment.vue"),
        },

        {
          path: "/dealer_report/index",
          name: "dealerReport",
          meta: { auth: true },
          beforeEnter: (to, from, next) => {
            if (store.state["auth"].isAdmin) {
              next();
            } else {
              next({ name: "dashboard" });
            }
          },
          component: () =>
            import("@/views/pages/finance/report/DealerReport.vue"),
        },
        {
          path: "/notification/index",
          name: "notifications",
          meta: { auth: true },
          component: () => import("@/views/pages/notification/Index.vue"),
        },
      ],
    },
    {
      path: "/auth/login",
      name: "login",
      component: () => import("@/views/pages/auth/Login.vue"),
    },

    {
      name: "not-found",
      path: "/:pathMatch(.*)*",
      component: () => import("@/views/pages/auth/Access.vue"),
    },
  ],
});
router.beforeEach((to, from, next) => {
  const isAuthentication = store.getters[`auth/${IS_USER_AUTH_GETTERS}`];
  if (to.meta.auth && !isAuthentication) {
    next({ name: "login" });
  } else if (!to.meta.auth && isAuthentication) {
    next({ name: "dashboard" });
  } else {
    next();
  }
});

export default router;
